export function stringNorm(str) {
  if (!str) return ''
  return str.toLowerCase().replace(/[\W_]/g, '')
}
